import LocomotiveScroll from "locomotive-scroll";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.isMobile = window.matchMedia("(max-width: 800px)").matches;
document.body.classList.add(window.isMobile ? "is-mobile" : "is-desktop");

let scrollContainer = document.querySelector(".scrollContainer");
function initLocoScroll(){
  


  const locoScroll = new LocomotiveScroll({
    el: scrollContainer,
    smooth: true,
    multiplier: 0.8,
  });
  window.locoScroll = locoScroll;

  locoScroll.on("scroll", () => {
    ScrollTrigger.update();
  });

  ScrollTrigger.scrollerProxy(scrollContainer, {
    scrollTop(value) {
      return arguments.length
        ? locoScroll.scrollTo(value, 0, 0)
        : locoScroll.scroll.instance.scroll.y;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },

    pinType: scrollContainer.style.transform ? "transform" : "fixed",
  });

  ScrollTrigger.defaults({
    scroller: scrollContainer,
  });

  ScrollTrigger.addEventListener("refresh", () => {
    locoScroll.update();
  });

  ScrollTrigger.refresh();

}

if(scrollContainer) initLocoScroll()



// toggle scroll
document.addEventListener("lock-scroll", (event) => {
  //loco scroll
  if(window.locoScroll){
    event.detail.open ? window.locoScroll.stop() : window.locoScroll.start();
  }
  // native scroll
  document.getElementsByTagName("body")[0].style.overflow = event.detail.open
    ? "hidden"
    : "visible";
});

const fadeins = gsap.utils.toArray("[data-appear]");

fadeins.forEach((box, i) => {
  const anim = gsap.fromTo(
    box,
    { autoAlpha: 0, y: 150 },
    { duration: 1, autoAlpha: 1, y: 0, ease: "power3.out" }
  );
  ScrollTrigger.create({
    trigger: box,
    scroller: ".scrollContainer",
    animation: anim,
    toggleActions: "play none none none",
    once: true,
  });
});


